module.exports = __webpack_public_path__ + "static/media/transparent.fc5da7b6.jpg";